<div class="main-div">
  <!-- <div class="nglotte d-none d-md-block">
    <ng-lottie [styles]="styles" [options]="options" (animationCreated)="onAnimate($event)">
    </ng-lottie>
  </div> -->
  <div class=" banner" id="banner" [ngClass]="{'arabic': lang === 'ar'}">
    <div class="container h-100">
      <div class="bannerSec row ">
        <div class=" left col-md-6 align-self-center order-2 order-md-1">
          <div class="banner-content text-center text-md-start mb-xl-5 pb-xl-5">
            <!-- <h1>{{"banner-heading" | translate}}</h1> -->
            <h1 [ngStyle]="getHeadingStyles()">{{"banner-heading" | translate}}</h1>
            <p class="sub-heading mb-lg-4 d-block px-md-0">{{"banner-para" | translate}} </p>
            <div class="">
              <div class="bottomSec text-center text-md-start">
                <a class="serLink" href="https://twitter.com/BestWeb3_" target="_blank">
                  <img src="assets/images/twitter.svg" alt="twitter" class="social-icon-twitter">
                </a>
                <a class="serLink " href="https://t.me/BestWeb3Official" target="_blank">
                  <img src="assets/images/telegram.svg" alt="telegram" class="social-icon-tele">
                </a>
                <a class="serLink " href="https://discord.gg/ujKmVVycsW" target="_blank">
                  <img src="assets/images/discord.svg" alt="discord" class="social-icon-discord">
                </a>
                <a class="serLink " href="https://linktr.ee/bestweb3official" target="_blank">
                  <img src="assets/images/iconn.svg" alt="linktree" class="social-icon-linktree">
                </a>
              </div>
              <div class="app-links text-center text-md-start">
                <a href="https://play.google.com/store/apps/details?id=com.bestwallet.mobile" target="_blank"
                  class="wd-100 wd-sm-28 me-2 mb-3">
                  <img src="./assets/images/google-pay.svg" alt="" class="">
                </a>
                <a href="https://apps.apple.com/gb/app/best-wallet/id6451312105" target="_blank"
                  class="wd-100 wd-sm-28 me-2 mb-3">
                  <img src="/assets/images/app-Store.svg" alt="" class="">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class=" right col-md-6 text-center order-1 order-md-2">
          <div class="large-slide mt-0 mr-md-5 pt-0 pt-md-0 position-relative  h-100">
            <img height="100%" src="/assets/images/home-img.svg" alt="hero image deskstop"
              class="img-fluid d-none d-md-block">
            <img height="100%" src="/assets/images/banner-mob-mob.svg" alt="" class="img-fluid-mob d-md-none">
          </div>
        </div>
      </div>
    </div>
    <!-- <p class="feature-title text-center text-white fw-semibold font-20 mb-4" translate>feature_title</p> -->
  </div>
</div>